<main role="main" class="page-Chantiers-infrastructures not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-breadcrumb></app-breadcrumb>
        <h2>{{bloc.Titre}}</h2>        
         <div [innerHTML]="bloc.Contenu"></div>
      </div>
    </div>
  </div>
  <section class="c-section-full">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="filtre">
            <p class="font-weight-bold size18">{{ "general.filtreActivitePort" | translate}}</p>
            <button class="btn btn-primary" [class.SelectColor]="activeIndex == i" type="button" (click)="Filter(FiltrePort.Port, i)" data-port="Port de Casablanca" *ngFor="let FiltrePort of FiltrePorts; let i = index">{{FiltrePort.Port | translate}}</button> 
          </div>
          <div class="card-slider" id="slider-chantier">
            <ol>
              <div class="card-slider-item col" *ngFor="let Chantier of ChantierFiltered">
                <div class="card"><a href="javascript:void(0)" [routerLink]="['/grands-chantiers/chantiers-infrastructures',Chantier.Id]"><img class="card-img-top" [src]="Chantier.PortImage" width="387" height="188" alt="...">
                  <div class="card-body">
                    <h3 class="card-title">{{Chantier.Titre}}</h3>
                    <span class="text-primary port-name">{{Chantier.Port | translate}}</span>
                  </div>
                  </a>
                </div>
              </div>
            </ol>
          </div> 
          </div>
      </div>
    </div>
  </section>
</main>